import cardValidator from 'card-validator';

const NO_ERROR = '';

export const validateExpiryDate = errors => value => {
    if (!value || !value.month || !value.year) {
        return errors.required;
    }

    if (!cardValidator.expirationDate(value).isValid) {
        return errors.invalidFormat;
    }

    return NO_ERROR;
};

export const validateCardNumber = errors => value => {
    if (!value) {
        return errors.required;
    }

    if (!cardValidator.number(value).isValid) {
        return errors.invalid;
    }

    return NO_ERROR;
};

export const validateCVV = (errors, maxLength = 3) => value => {
    if (!value) {
        return errors.required;
    }

    if (!cardValidator.cvv(value, maxLength).isValid) {
        return errors.invalidFormat;
    }

    return NO_ERROR;
};
